var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"wordcloud",staticClass:"key",attrs:{"id":"key","element-loading-background":"rgba(16,164,178, 0.2)"}})])}
var staticRenderFns = []

export { render, staticRenderFns }